export const initContact5 = () => {
    // @todo: copy postcode from new instance navigation section

    const form_contact5 = document.getElementById('contact5__form')
    const section_contact5 = document.querySelector('.contact5__section')
    const btn_show_form = document.getElementById('js-contact5__show-form')
    const btn_hide_form = document.getElementById('js-contact5__hide-form')

    if (btn_show_form) {
        btn_show_form.addEventListener('click', () => {
            section_contact5.classList.replace('contact5__section--state-1', 'contact5__section--state-2')
        })
    }

    if (btn_hide_form) {
        btn_hide_form.addEventListener('click', (e) => {
            e.preventDefault()
            form_contact5.reset()
            section_contact5.classList.replace('contact5__section--state-2', 'contact5__section--state-1')
        })
    }
}
